import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { NotificationFieldsFragment, NotificationType, useAcknowledgeNotificationMutation } from '../../../../../../generated/core-api/graphql-react-query';
import AvailableCommandNotificationBox from './Components/boxes/AvailableCommandNotificationBox';
import CardCommentNotificationBox from './Components/boxes/CardCommentNotificationBox';
import CommandRequestStatusChangedNotificationBox from './Components/boxes/CommandRequestStatusChangedNotificationBox';
import ContentRequestCommentedNotificationBox from './Components/boxes/ContentRequestCommentedNotificationBox';
import ContentRequestCreatedNotificationBox from './Components/boxes/ContentRequestCreatedNotificationBox';
import ContentRequestUpdatedNotificationBox from './Components/boxes/ContentRequestUpdatedNotificationBox';
import NewContentNotificationBox from './Components/boxes/NewContentNotificationBox';
import ProjectAssignedNotificationBox from './Components/boxes/ProjectAssignedNotificationBox';
import UserConfirmedNotificationBox from './Components/boxes/UserConfirmedNotificationBox';
import UserInvitedNotificationBox from './Components/boxes/UserInvitedNotificationBox';
import UserRoleChangedNotificationBox from './Components/boxes/UserRoleChangedNotificationBox';
import StyledButton from './styles';

function NotificationBoxContent(props: { notification: NotificationFieldsFragment }) {
  const { notification } = props;
  switch (notification.event.eventType) {
    case NotificationType.NewContent:
      return <NewContentNotificationBox notification={notification} />;
    case NotificationType.ProjectAssigned:
      return <ProjectAssignedNotificationBox notification={notification} />;
    case NotificationType.UserConfirmed:
      return <UserConfirmedNotificationBox notification={notification} />;
    case NotificationType.UserInvited:
      return <UserInvitedNotificationBox notification={notification} />;
    case NotificationType.UserRoleChanged:
      return <UserRoleChangedNotificationBox notification={notification} />;
    case NotificationType.CardComment:
      return <CardCommentNotificationBox notification={notification} />;
    case NotificationType.AvailableCommand:
      return <AvailableCommandNotificationBox notification={notification} />;
    case NotificationType.CommandRequestStatusChanged:
      return <CommandRequestStatusChangedNotificationBox notification={notification} />;
    case NotificationType.ContentRequestCreated:
      return <ContentRequestCreatedNotificationBox notification={notification} />;
    case NotificationType.ContentRequestUpdated:
      return <ContentRequestUpdatedNotificationBox notification={notification} />;
    case NotificationType.ContentRequestCommented:
      return <ContentRequestCommentedNotificationBox notification={notification} />;

    default:
      return <div />;
  }
}

export default function NotificationBox(props: { notification: NotificationFieldsFragment, onClose: () => void }) {
  const { notification, onClose } = props;
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const mutation = useAcknowledgeNotificationMutation({
    onSuccess() {
      queryClient.invalidateQueries(['identityNotifications.infinite']);
      setTimeout(() => {
        queryClient.invalidateQueries(['identityNumNotifications']);
      }, 3000);
    },
  });
  function onClick() {
    mutation.mutate({ input: { eventId: notification.eventId } });
    switch (notification.event.eventType) {
      case NotificationType.NewContent:
      case NotificationType.ProjectAssigned:
      case NotificationType.CardComment:
      case NotificationType.AvailableCommand:
      case NotificationType.ContentRequestCreated:
      case NotificationType.ContentRequestUpdated:
      case NotificationType.ContentRequestCommented:
        navigate(`/notifications/${notification.eventId}`);
        onClose();
        break;

      default:
        onClose();
        break;
    }
  }
  return (
    <StyledButton onClick={() => { onClick(); }} acknowledged={!!notification.acknowledgeDate}>
      <NotificationBoxContent notification={notification} />
      <div className="acknowledge-indicator">
        <FiberManualRecordIcon />
      </div>
    </StyledButton>
  );
}
